import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DatePipe } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';

// Core Components
import { AppComponent } from './app.component';

// Routing Module
import { AppRoutingModule } from './app-routing.module';

// Services
import { InscritService } from '../services/inscrit.service';
import { PersonnelService } from '../services/personnel.service';
import { LoginService } from '../services/login.service';
import { PayementService } from 'src/services/payement.service';
import { FactureService } from 'src/services/facture.service';
import { PayementPerService } from 'src/services/payementPer.service';
import { MatiereService } from 'src/services/matiere.service';
import { AuthenticationService } from 'src/services/authentication.service';
import { BasicAuthHtppInterceptorService } from 'src/services/basic-auth-htpp-interceptor.service';
import { UserService } from 'src/services/user.service';
import { DownloadPdfService } from 'src/services/download-pdf.service';
import { EtablissementService } from 'src/services/etablissement.service';

// Shared Module (imports communs)
import { SharedModule } from './shared/shared.module';

// Date Configuration
import { FrenchDateAdapter } from './shared/french-date-adapter';
import { FRENCH_DATE_FORMATS } from './shared/french-date-formats';

// Enregistrer la localisation française
registerLocaleData(localeFr);

/**
 * Factory pour la configuration de TranslateModule
 */
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    // Angular Core Modules
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    
    // App Routing Module (contient tous les routes avec lazy loading)
    AppRoutingModule,
    
    // Third Party UI Modules
    FontAwesomeModule,
    NgbModule,
    NgMultiSelectDropDownModule.forRoot(),
    
    // Shared Module (composants communs, directives, pipes)
    SharedModule,
    
    // Translation Module
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      defaultLanguage: 'ar'
    })
  ],


  providers: [
    PayementPerService,
    PayementService,
    InscritService,
    DatePipe,
    DownloadPdfService,
    PersonnelService,
    LoginService,
    MatiereService,
    UserService,
    EtablissementService,
    AuthenticationService,
    FactureService,
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthHtppInterceptorService, multi: true },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: DateAdapter, useClass: FrenchDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: FRENCH_DATE_FORMATS }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
